import { debounce } from "../utility/UtilityFunctions";

export default class ReadMore {
    constructor(element) {
        this.element = element;
        this.ctaText = element.querySelector('.c-cta__text');
        this.paragraphs = Array.from(this.ctaText.querySelectorAll('p'));
        this.characterLimit = 230;
        this.collapsed = false;
        this.isCtaLede = element.classList.contains('c-cta--lede');
        this.hiddenParagraphs = [];

        this.wrapParagraphs();
        this.initialize();
        this.bindResizeHandler();
    }

    wrapParagraphs() {
        const wrapper = document.createElement('div');
        wrapper.className = 'c-cta__text-content';

        this.paragraphs.forEach(p => wrapper.appendChild(p));
        this.ctaText.appendChild(wrapper);
        this.contentWrapper = wrapper;
    }

    initialize() {
        this.hiddenParagraphs = this.getHiddenParagraphs();

        if (this.hiddenParagraphs.length === 0) return;

        this.collapsed = true;

        if (this.isCtaLede) {
            this.ctaButtonGroup = this.element.querySelector(".c-cta__button-group");
        }

        this.updateDisplayState();
        this.insertToggleButton();
    }

    bindResizeHandler() {
        window.addEventListener('resize', debounce(() => this.calculateHeights(), 250));
    }

    getHiddenParagraphs() {
        let charCount = 0;
        for (let i = 0; i < this.paragraphs.length; i++) {
            charCount += this.paragraphs[i].textContent.length;
            if (charCount > this.characterLimit) {
                return this.paragraphs.slice(i + 1);
            }
        }
        return [];
    }

    calculateHeights() {
        const totalHeight = this.getParagraphsHeight(this.paragraphs);
        const visible = this.paragraphs.filter(p => !this.hiddenParagraphs.includes(p));
        const initialHeight = this.getParagraphsHeight(visible);

        this.ctaText.style.setProperty('--visible-height', `${totalHeight}px`);
        this.ctaText.style.setProperty('--initial-height', `${initialHeight}px`);
    }

    getParagraphsHeight(paragraphs) {
        return paragraphs.reduce((total, p) => {
            const styles = getComputedStyle(p);
            const marginTop = parseFloat(styles.marginTop);
            const marginBottom = parseFloat(styles.marginBottom);
            return total + p.offsetHeight + marginTop + marginBottom;
        }, 0);
    }

    updateDisplayState() {
        this.ctaText.setAttribute("aria-expanded", String(!this.collapsed));
        this.ctaText.classList.toggle("c-cta__text--collapsed", this.collapsed);

        this.paragraphs.forEach(p => {
            const shouldHide = this.collapsed && this.hiddenParagraphs.includes(p);
            p.classList.toggle('hidden', shouldHide);
        });

        this.calculateHeights();
    }

    insertToggleButton() {
        const button = document.createElement("button");
        button.className = "c-button c-button--underline c-button--read-more";
        button.textContent = "Read more";

        button.addEventListener("click", () => {
            this.collapsed = !this.collapsed;
            button.textContent = this.collapsed ? "Read more" : "Read less";
            this.updateDisplayState();
        });

        this.ctaText.after(button);
    }
}